import { useState } from "react"
import Alert from "@common/alert"
import Button, { ButtonProps } from "@common/buttons/button"
import { Status } from "@common/types"
import { useToast } from "@common/toast/toastProvider"
// getDetailsForSubmit -> function that allows parent provide the final details that needs to be submitted.
// noSubmitMode -> default false. If true, then submit is not called, only onClick is called
// onSimpleClick -> is called only when noSubmitMode == true. ie button works like a simple button

export interface ButtonFormWithSubmitProps extends ButtonProps {
  children: React.ReactNode
  showErrorMsg?: boolean
  errMessageType?: "alert" | "toast"
  submitFunction?: () => Promise<any>
  onSubmitSuccess?: (data: any) => void
  onSubmitFail?: (message?: string[], data?: any, status?: number) => void
  onSubmit?: () => void
  onSubmitResponse?: (data: any) => void
  noSubmitMode?: boolean
  onSimpleClick?: () => void
}

export default function ButtonFormWithSubmit({
  children,
  showErrorMsg,
  submitFunction,
  onSubmit,
  onSubmitResponse,
  onSubmitSuccess,
  onSubmitFail,
  noSubmitMode = false,
  onSimpleClick,
  errMessageType,
  //Button Props
  ...buttonProps
}: ButtonFormWithSubmitProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>()
  const { showToast } = useToast()
  async function submit() {
    setErrorMessage(null)
    if (noSubmitMode) {
      if (onSimpleClick) onSimpleClick()
      return
    }

    if (onSubmit) onSubmit()

    if (!submitFunction) {
      return
    }

    setIsLoading(true)
    const { data, status, message } = await submitFunction()

    setIsLoading(false)
    if (onSubmitResponse) onSubmitResponse(data)
    if (status === Status.Success && onSubmitSuccess) onSubmitSuccess(data)
    else {
      if (errMessageType === "toast") showToast({ message, type: "error" })
      else setErrorMessage(message)
      if (onSubmitFail) {
        onSubmitFail(message, data, status)
      }
    }
  }

  return (
    <div className="relative">
      {showErrorMsg && errorMessage && (
        <div className="absolute right-0  pb-2 transform  -translate-y-full whitespace-nowrap">
          <Alert variant="simpleError">{errorMessage}</Alert>
        </div>
      )}
      <Button {...buttonProps} isLoading={isLoading} onClick={submit}>
        {children}
      </Button>
    </div>
  )
}
